import React, { useEffect, useState, useContext } from 'react';
import { GlobalContext } from '../../Contexts/GlobalContext';
import useFetch from '../../CustomHooks/useFetch';

export default function useOptionGroups(props) {
    const globalContext = useContext(GlobalContext);
    const [getOptionGroupsHookResponse, getOptionGroupsHook] = useFetch();
    const [deleteOptionGroupHookResponse, deleteOptionGroupHook] = useFetch();


    useEffect(
        () => {
            getOptionGroups();
        }, []
    )

    const getOptionGroups = () => {
        getOptionGroupsHook(
            {
                url: '/admin/food-options?PageNumber=1&PageSize=100',
                method: 'GET',
                postData: null,
                addTokenHeader: true,
            }
        )
    }

    const deleteOptionGroup = (optionGroupId) => {
        globalContext.dispatchMethod({ type: 'SET_MESSAGE', value: { message: 'Deleting option group...', showButton: false } });
        deleteOptionGroupHook(
            {
                url: '/admin/food-options/' + optionGroupId + '?softDelete=true',
                method: 'DELETE',
                postData: null,
                addTokenHeader: true,
            }
        )
    }
    


    return [getOptionGroupsHookResponse, getOptionGroups, deleteOptionGroup, deleteOptionGroupHookResponse];
}
